import { Input } from "antd";
import { ReactElement, ReactNode } from "react";

import "./custom-input.style.scss";

interface CustomInputProps {
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  style?: { [key: string]: string };
  className?: string;
  prefix?: ReactNode;
  type?: string;
  disabled?: boolean;
  dir?: string;
  maxLength?: number;
}

const CustomInput: React.FC<CustomInputProps> = ({
  value,
  onChange,
  placeholder,
  style,
  type = "text",
  disabled = false,
  prefix,
  dir,
  maxLength,
}: CustomInputProps): ReactElement => {
  return (
    <div className="custom-input-container">
      <Input
        type={type}
        prefix={prefix}
        disabled={disabled}
        value={value}
        onChange={onChange}
        className="input-field-container"
        placeholder={placeholder}
        style={style}
        dir={dir}
        maxLength={maxLength}
      />
    </div>
  );
};

export default CustomInput;
